import { ShowGalleryComponent } from './modals';

export * from './modals';

export const Modal = [ShowGalleryComponent];
